import { Injectable } from '@angular/core';
import { EncrdecrService } from '../Auth/encrdecr.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConvertToJSONService } from './convert-to-json.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RiskProfileService {

  ServerUrl = environment.ServerUrl

  constructor(private EncrdecrService: EncrdecrService, private http: HttpClient,
    private ConvertToJSON: ConvertToJSONService) { }
  GetToken() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    console.log('token::  ' + token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Basic ${TOKEN}`,
      })
    }
    return tokenOption;
  }
  InsertDetails(data: any): Observable<any> {
    let url = `${this.ServerUrl}/api/RiskProfile/InsertDetails`;
    const tokenOption = this.GetToken();
    // let req_str = JSON.stringify(data);
    // const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, data, tokenOption).pipe();
  }
  GetRiskProfileSettings(trans,clientid):Observable<any>{
    const token = this.GetToken();
    let trans_type = this.EncrdecrService.setEncr(trans);
    let REFF_ID = this.EncrdecrService.setEncr(clientid);
    let SUrl = `${this.ServerUrl}/api/DropDown/ListDetails?TRANS_TYPE=${trans_type}&REFF_ID=${REFF_ID}`;
    let url = SUrl.split('?')[0];
    let body = this.ConvertToJSON.QueryStringToJSON(SUrl.split('?')[1]);
    console.log("Risk Profile URL is " + url);
    console.log("Risk Profile body is " + JSON.stringify(body));
    return this.http.post<any>(url, body, token);
  }
  GetClientRiskProfile(data: any): Observable<any> {
    let url = `${this.ServerUrl}/api/RiskProfile/GetClientRiskProfile`;
    const tokenOption = this.GetToken();
    // let req_str = JSON.stringify(data);
    // const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, data, tokenOption).pipe();
  }
}
